SidebarKo = App.loadClass "core::viewmodels/filters/Sidebar"
BaseHandler = App.loadClass "core::reports/BaseHandler"

class exports.Communicate_Handler extends BaseHandler

    init: (filterUrl = null, @imp_structure = null) ->
        @filterUrl = if filterUrl? then filterUrl else 'backend/portal/communicate/filters'
        @layoutUrl = 'backend/portal/communicate/'
        @loadLayout()


    afterLoadLayout: () ->
        # initialize filters
        @initFilters()

        # Event Listener for Apply Filter button
        $(@layoutSelector).find('.apply-filters').bind 'click', () =>
            @message_dialog.populateBcc()

        # Event Listener for Clear Filter button
        $(@layoutSelector).find('.clear-filters').bind 'click', () =>
            @message_dialog.emptyUsersFromBcc()
            @message_dialog.clearUploadedFile()

        # Allow toggling open/closed on "filtering by"
        $(@layoutSelector).find('.report-applied-filters').undelegate().delegate '.applied-filter-header', 'click', () ->
            $(this).siblings('.applied-filter-value-container').slideToggle('fast')
            if $(this).find('.caret-arrow').hasClass('caret-right')
                $(this).find('.caret-arrow').removeClass('caret-right')
            else
                $(this).find('.caret-arrow').addClass('caret-right')

        # If different report filters are to be used pass them to the front
        @sidebar.fetchFilters @filterUrl, () =>
            @message_dialog = @createSubHandler 'portal::handlers/communicate/Communicate_Dialog'
            if @message_dialog
                @message_dialog.init(@imp_structure?)


    initFilters: () ->
        # If a filter structure is coming from somewhere else use that
        if @imp_structure?
            filters = @imp_structure
        else
            # Else use native filters
            filters = [
                {
                    name: 'Region Filters',
                    filters: [
                        {
                            name: 'states'
                            display_name: 'State'
                        },
                        {
                            name: 'zones'
                            display_name: 'Zone'
                        },
                        {
                            name: 'zips'
                            display_name: 'ZIP Code'
                        }
                    ]
                },
                {
                    name: "Operation Filters",
                    filters: [
                        {
                            name: 'companies'
                            display_name: 'Company'
                        },
                        {
                            name: 'account_types'
                            display_name: 'Account Type'
                            class: 'dropup'
                        },
                        {
                            name: 'farms'
                            display_name: 'Farm'
                            class: 'dropup'
                        },
                        {
                            name: 'fields'
                            display_name: 'Field'
                            class: 'dropup'
                        }
                    ]
                },
                {
                    name: "Communicate Filters",
                    filters: [
                        {
                            name: 'last_interaction'
                            display_name: 'Last Touchpoint'
                            control_type: 'datepicker'
                        },
                        {
                            name: 'methods'
                            display_name: 'Contact Method'
                            class: 'dropup'
                            control_type: 'single_dropdown'
                            deletable: false
                            values: [
                                { key: 'Email', value: 'Email + TouchPoint' }
                                { key: 'SMS', value: 'SMS + TouchPoint' }
                                { key: 'TouchPoint', value: 'TouchPoint' }
                            ],
                            selected_values: [
                                { key: 'TouchPoint', value: 'TouchPoint' }
                            ],
                        },
                        {
                            name: 'owners'
                            display_name: 'User'
                            class: 'dropup'
                        },
                    ]
                }
            ]


        @sidebar = new SidebarKo filters
        ko.cleanNode $(@layoutSelector)[0]
        ko.applyBindings @sidebar, $(@layoutSelector)[0]
